<label class="container" [for]="id()">
  @if (type() === 'radio') {
    <input
      type="radio"
      [attr.name]="name()"
      [value]="value()"
      [formControl]="controller()"
      [id]="id()" />
  } @else {
    <input
      type="checkbox"
      [attr.name]="name()"
      [value]="value()"
      [formControl]="controller()"
      [id]="id()" />
  }
  <span class="checkmark" [attr.data-testid]="'checkbox-' + name()"  >
    <orbit-fa-icon [iconName]="checkmark" />
  </span>
</label>
@if (label() && id()) {
  <label class="label" [for]="id()">{{ label() }}</label>
}
